import cloneDeep from 'lodash/cloneDeep';

// Primary sort on grantor, secondary sort on grant name
const Private = {
  alphabeticalSort: function (incentives, direction) {
    return incentives.sort((a, b) => {
      let name = (incentive) => `${incentive.grantor}`;
      let sub_name = (incentive) => `${incentive.name}`;
      switch (direction) {
        case 'asc':
          return name(a).localeCompare(name(b)) === 0
            ? sub_name(a).localeCompare(sub_name(b))
            : name(a).localeCompare(name(b));
        case 'desc':
          return name(b).localeCompare(name(a)) === 0
            ? sub_name(b).localeCompare(sub_name(a))
            : name(b).localeCompare(name(a));
        default:
          return incentives;
      }
    });
  },
  priceSort: function (incentives, direction) {
    return incentives.sort((a, b) => {
      let price = (incentive) => incentive?.evaluation?.amount_in_purchase;
      switch (direction) {
        case 'asc':
          return price(a) - price(b);
        case 'desc':
          return price(b) - price(a);
        default:
          return incentives;
      }
    });
  },
};
export const providerFilter = (incentives, provider) => {
  return incentives?.filter((incentive) => {
    if (!provider) {
      return true;
    }

    return (
      incentive.grantor === provider ||
      [
        'Country',
        'Section',
        'State',
        'District',
        'Municipality',
        'Miscellaneous Organization',
      ].includes(incentive.grantor_type)
    );
  });
};

const PRIORITY_IDS = [787, 718, 681, 272];
const sortByPriorityIds = (incentives) => {
  const priorityItems = PRIORITY_IDS.map((id) =>
    incentives.find((item) => item.id === id)
  ).filter(Boolean);
  const remainingItems = incentives.filter(
    (item) => !PRIORITY_IDS.includes(item.id)
  );
  return [...priorityItems, ...remainingItems];
};

export const sortIncentivesCatalog = (incentives, sortType, sortDirection) => {
  const clonedIncentives = cloneDeep(incentives);

  let sorted = [];
  switch (sortType) {
    case 'alphabetical':
      sorted = Private.alphabeticalSort(clonedIncentives, sortDirection);
      break;
    default:
      sorted = Private.priceSort(clonedIncentives, sortDirection);
      break;
  }

  return sortByPriorityIds(sorted);
};
